(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bye-capri-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* FAQ acordeón */
  var accs = document.querySelectorAll('#byeFaq .bye-acc');
  accs.forEach(function(acc){
    var q = acc.querySelector('.bye-acc__q');
    var a = acc.querySelector('.bye-acc__a');
    q.addEventListener('click', function(){
      var open = acc.classList.contains('is-open');
      accs.forEach(function(o){
        o.classList.remove('is-open');
        o.querySelector('.bye-acc__a').style.maxHeight = null;
        o.querySelector('.bye-acc__q').setAttribute('aria-expanded','false');
      });
      if(!open){
        acc.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
        q.setAttribute('aria-expanded','true');
      }
    });
  });

  /* Sticky bar: aparece al pasar el hero */
  var sticky = document.getElementById('byeSticky');
  var hero = document.querySelector('.bye-hero');
  if(sticky && hero && 'IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ sticky.classList.remove('is-visible'); }
        else { sticky.classList.add('is-visible'); }
      });
    }, {threshold:0.15});
    obs.observe(hero);
  }

  /* Aparición al hacer scroll (respeta reduced-motion) */
  var lp = document.querySelector('.bye-lp');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(lp && !reduce && 'IntersectionObserver' in window){
    lp.classList.add('has-reveal');
    var rObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); rObs.unobserve(e.target); }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -7% 0px'});
    document.querySelectorAll('.bye-lp section').forEach(function(s){ rObs.observe(s); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
